import type { RouteObject } from 'react-router-dom';
import { ROUTE_LABS_ORDER, ROUTE_LABS_ORDER_STEP_1, ROUTE_LABS_ORDER_STEP_2, ROUTE_LABS_ORDER_STEP_3, ROUTE_LABS_ORDER_STEP_4, ROUTE_LABS_ORDER_STEP_5 } from '../../../constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { Page } from './labs-order.page';
import { Step1Summary } from './steps/step-1-summary';
import { Step2UserInfo } from './steps/step-2-user-info';
import { Step3SelectLab } from './steps/step-3-select-lab';
import { Step4Consent } from './steps/step-4-consent';
import { Step5Success } from './steps/step-5-success';

export const routeLabsOrder: RouteObject = {
  path: ROUTE_LABS_ORDER,
  Component: Page,
  loader: setTitleFromLoader('Labs Order'),
  children: [
    {
      path: ROUTE_LABS_ORDER_STEP_1,
      Component: Step1Summary,
    },
    {
      path: ROUTE_LABS_ORDER_STEP_2,
      Component: Step2UserInfo,
    },
    {
      path: ROUTE_LABS_ORDER_STEP_3,
      Component: Step3SelectLab,
    },
    {
      path: ROUTE_LABS_ORDER_STEP_4,
      Component: Step4Consent,
    },
    {
      path: ROUTE_LABS_ORDER_STEP_5,
      Component: Step5Success,
    },
  ],
};